<template>
    <c-sidebar-nav class="p-0">
        <slot />
    </c-sidebar-nav>
</template>
<script setup>
import { CSidebarNav } from '@coreui/vue/dist/esm/components/sidebar/index.js';
</script>
